import { ISuccessRateResponse } from '@core/market-data-sdk';
import { ChartContext } from '../interface';
import { getBenchmarkColor } from '../components/benchmarks/benchmark-color';
import { INDEX_TICKER_TO_NAME } from '../components/benchmarks/constants';

interface ICreateSuccessRateSeriesProps {
  response: ISuccessRateResponse;
  benchmark?: string;
  identifier?: string;
  color?: string;
}

export const createSuccessRateSeries = ({
  response,
  benchmark,
  identifier,
  color,
}: ICreateSuccessRateSeriesProps): ChartContext.IChartSeries => {
  let serieName = 'Rentabilidade > 0%';

  if (benchmark) {
    // Get the proper benchmark name from the constants
    const benchmarkKey = benchmark?.split(':')?.[0];
    const benchmarkName =
      (INDEX_TICKER_TO_NAME as any)[benchmarkKey] ||
      (INDEX_TICKER_TO_NAME as any)[benchmark] ||
      benchmark.toUpperCase();
    serieName = `Ativo vs. ${benchmarkName}`;
  }

  const filteredData = Object.entries(response.timeframe).filter(
    ([key, value]) => {
      const months = parseInt(key.match(/hist_(\d+)_months/)?.[1] || '0');
      return months <= 60;
    }
  );

  // Use getBenchmarkColor if benchmark is provided and no custom color is set
  const finalColor =
    color || (benchmark ? getBenchmarkColor(benchmark) : undefined);

  return {
    id: benchmark || identifier,
    name: serieName,
    type: 'column',
    color: finalColor,
    opacity: 1,
    data: filteredData.map(([_, value]) => value),
  };
};
